import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { class: "radio-group" }
const _hoisted_3 = { class: "radio-text" }

import { VIconSvg } from "@/components";
import { computed } from "vue";
import { getRandomId } from "@/mixins/global.mixin";
import { kebabCase } from "lodash";
import { TranslateResult } from "vue-i18n";

interface Props {
  disabled?: boolean;
  options: Array<{
    label: string | TranslateResult;
    code: string;
  }>;
  title?: string | TranslateResult;
  value?: string | number;
  required?: boolean;
  description?: string | TranslateResult;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VInputRadioGroup',
  props: {
    disabled: { type: Boolean, default: false },
    options: { default: () => [
    {
      label: "",
      code: "",
    },
  ] },
    title: { default: "" },
    value: { default: "" },
    required: { type: Boolean, default: false },
    description: { default: "" }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const activeItem = computed({
  get() {
    return props.value;
  },
  set(value) {
    emit("input", value);
  },
});

const name = computed(() => `radio-${getRandomId()}`);

const inputWrapperClasses = computed(() => {
  const classes = {
    "input-required": props.required,
  };

  return [classes];
});

const isShownInfoIcon = computed(() => !!props.description);

return (_ctx: any,_cache: any) => {
  const _component_t_radio = _resolveComponent("t-radio")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-radio-container", inputWrapperClasses.value])
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
          (isShownInfoIcon.value)
            ? (_openBlock(), _createBlock(_unref(VIconSvg), {
                key: 0,
                tooltip: _ctx.description,
                name: "InfoCircle2",
                color: "fc-stroke",
                size: "xs"
              }, null, 8, ["tooltip"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
        return (_openBlock(), _createElementBlock("label", {
          key: index,
          class: "radio-item"
        }, [
          _createVNode(_component_t_radio, {
            id: item.code.toString(),
            modelValue: activeItem.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeItem).value = $event)),
            disabled: _ctx.disabled,
            class: "radio",
            name: name.value,
            value: item.code,
            "data-cy": `radio-${_unref(kebabCase)(item.code)}`
          }, null, 8, ["id", "modelValue", "disabled", "name", "value", "data-cy"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
        ]))
      }), 128))
    ])
  ], 2))
}
}

})